import { axiosNTL, axiosNT } from '../../../services/axios';

import ContentSubtypeData from "../types/ContentSubtypeData";


const list = () => axiosNTL
	.get("contentSubType/getContentSubType")
	.then((res: any) => {
		let cst: ContentSubtypeData[] = res.responseObject;

		return Promise.resolve(cst);
	})

const listByContentTypeCode = (code: string, templateType?: string, ignoreEmptyRules?: boolean) => {
	const params = [];
	ignoreEmptyRules && params.push({ key: 'ignoreEmptyRules', value: ignoreEmptyRules });
	templateType && params.push({ key: 'templateType', value: templateType })
	const queryParams = params.map(query => `${query.key}=${query.value}`).join('&');
	return axiosNT.get(`contentSubType/getContentSubType/${code}?${queryParams}`)
	.then((res: any) => {
		let cst: ContentSubtypeData[] = res.responseObject;

		return Promise.resolve(cst);
	})
}

const contentSubtypeServices = {
	list,
	listByContentTypeCode,
};

export default contentSubtypeServices;